import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button, Chip, Divider, Grid2, IconButton, Paper, Stack, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, } from '@mui/material';
import { IoMdClose } from 'react-icons/io';
import { useParams } from 'react-router-dom';
import PaginationComponent from 'components/ui-components/PaginationComponent';
import TableDataGrid from 'components/grid/TableDataGrid';
import moment from 'moment';
import { useGetAllClearanceQuery } from "store/slices/apis/clearancePackageSlice";
import ExportToExcel from "../Risk/ExportToExcel";
import ExportToPDF from "../Risk/ExportToPDF";


const StyledTableHead = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#37352F', padding: '10px 10px 10px 15px', lineHeight: '100%'
}));

const StyledTableRow = styled(TableCell)(({ theme }) => ({
    fontWeight: "400", fontSize: '12px', color: '#000000', padding: '12px 12px 12px 15px', lineHeight: '100%',
}));

export default function MilestonesPopup({ title, value, status, onClose, onOpen, data = [] }) {
    const theme = useTheme();

    const columns = [
        {
            name: "Milestone ID",
            field: "milestone_number",
            renderer(params) {
                return (
                    <Chip
                        label={params?.milestone_number}
                        size="small"
                        sx={{
                            fontSize: "12px",
                            "& .MuiChip-label": {
                                paddingLeft: "8px",
                                paddingRight: "8px",
                                fontWeight: 600,
                            },
                        }}
                    />
                );
            },
            renderExport(row) {
                return row?.milestone_number || "";
            }
        },
        {
            name: "Milestone Name",
            field: "milestone_name",
            renderExport(row) {
                return row?.milestone_name || "";
            }
        },
        {
            name: "Plan Finish Date",
            field: "plan_date",
            renderer(params) {
                return params?.plan_date ? moment(params.plan_date).format("DD/MM/YY") : "N.A.";
            },
            renderExport(row) {
                return row?.plan_date ? moment(row.plan_date).format("DD/MM/YY") : "N.A.";
            }
        },
        {
            name: "Actual Finish Date",
            field: "actual_date",
            renderer(params) {
                return params?.actual_date ? moment(params.actual_date).format("DD/MM/YY") : "N.A.";
            },
            renderExport(row) {
                return row?.actual_date ? moment(row.actual_date).format("DD/MM/YY") : "N.A.";
            }
        },
    ];

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                maxWidth={'lg'}
                open={onOpen}
                onClose={onClose}
                disableAutoFocus
                disableEnforceFocus
                disableRestoreFocus
                sx={{
                    '& .MuiDialog-paper': {
                        overflowY: 'inherit'
                    }
                }}
            >
                <DialogTitle sx={{ fontSize: '20px', color: '#696969' }}>Milestones from:- {title}</DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <IoMdClose style={{ fontSize: '20px' }} />
                </IconButton>
                <Divider sx={{ w: 1 }} />
                <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid2 container spacing={2}>
                            <Grid2 container spacing={2} size={12}>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToExcel data={data} columns={columns} fileName="milestone_export" />
                                </Grid2>
                                <Grid2 xs={12} sm={6}>
                                    <ExportToPDF data={data} columns={columns} fileName="milestone_export" />
                                </Grid2>
                            </Grid2>
                            <Grid2 size={12}>
                                <TableDataGrid columns={columns} data={data} isLoading={false} />
                                {/* <Box sx={{ display: "flex", justifyContent: "end" }}>
                                    <PaginationComponent
                                        pageNumber={openCloseData?.pagination?.currentPage || 1}
                                        totalPages={openCloseData?.pagination?.totalPages || 1}
                                        onPageChange={setPageNumber}
                                    />
                                </Box> */}
                            </Grid2>
                        </Grid2>
                    </Box>
                </DialogContent>
            </Dialog>
        </React.Fragment >
    );
}